import React from 'react';
import Imgix from 'react-imgix';
import styled from 'styled-components';
import { BodyThree } from '../../../../../../styles/theme/default/typography';
import { getFabricFullName, getImgixUrl } from '../../../../../../utils/helper';

const Wrapper = styled.div`
  .image-container {
    width: 100px;
    height: 100px;
  }

  .fabric-name {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .composition-durability-container {
    margin-top: 16px;
    margin-bottom: 16px;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }
`;

function Description({ productData }) {
  const { fabric, supplier } = productData;
  const { material, materials, image, description, pattern } = fabric;
  const { durability, composition } = material;

  const fabricName = getFabricFullName(fabric);

  if (supplier.id) {
    // check materials to find one with the same supplier_id
    const materialFromSupplier = materials.find((material) => material.supplier_id === supplier.id);
    if (materialFromSupplier) {
      const { durability, composition } = materialFromSupplier;
    }
  }

  const note =
    pattern?.id && pattern?.id != 15
      ? pattern?.id == 3
        ? 'Please note each piece is made to order. Color may vary slightly from image.'
        : 'Please note each piece is made to order. Pattern placement and color may vary slightly from image.'
      : '';

  return (
    <Wrapper>
      <div className="image-container">
        <ImageContainer>
          <div className="image-wrapper">
            <Imgix
              imgixParams={{ auto: 'compress,format' }}
              className="fabric-image"
              sizes="160px"
              src={getImgixUrl(image)}
              htmlAttributes={{
                alt: fabricName
              }}
            />
          </div>
        </ImageContainer>
      </div>
      <div className="fabric-name">
        <BodyThree bold={true}>{fabricName}</BodyThree>
      </div>
      <div className="fabric-description">
        <BodyThree color="#4B4B4B">{description}</BodyThree>
      </div>
      <div className="composition-durability-container">
        {composition && (
          <div className="composition">
            <BodyThree fontWeight={500} color="black">
              Composition
            </BodyThree>
            <BodyThree color="#4B4B4B">{composition}</BodyThree>
          </div>
        )}
        {durability && (
          <div className="durability">
            <BodyThree fontWeight={500} color="black">
              Durability
            </BodyThree>
            <BodyThree color="#4B4B4B">{durability}</BodyThree>
          </div>
        )}
      </div>
      {note && (
        <BodyThree color="#4B4B4B">
          Please note each piece is made to order. Pattern placement and color
          may vary slightly from image.
        </BodyThree>
      )}
    </Wrapper>
  );
}

export default Description;

const ImageContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-bottom: 100%;
  overflow: hidden;

  .image-wrapper {
    position: absolute !important;
    top: 0;
    left: 0;
    background: #f7f9fa;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    overflow: hidden;

    .fabric-image {
      transition: all 0.5s ease;
      position: absolute;
      max-width: 100%;
      max-height: 100%;
      height: 100%;
      width: auto;
    }
  }
`;
